import React, { Fragment } from "react";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

const ControlButtons = (props) => {
    if (!Array.isArray(props.items)) return null;
    return (
        <Fragment>
            {props.items.map((button, index) => (
                <Box m={2} display="inline" key={index}>
                    <ThemeProvider theme={button.type} key={index}>
                        {button.link ? (
                            <Button
                                variant="contained"
                                color="primary"
                                endIcon={button.icon}
                                to={button.link}
                                component={Link}
                                role={button.role}
                            >
                                {button.caption}
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                color="primary"
                                endIcon={button.icon}
                                onClick={button.action}
                                role={button.role}
                                style={{ backgroundColor: button?.color }}
                            >
                                {button.caption}
                            </Button>
                        )}
                    </ThemeProvider>
                </Box>
            ))}
        </Fragment>
    );
};

ControlButtons.defaultProps = {};
ControlButtons.propTypes = {
    items: PropTypes.array.isRequired,
};

export default ControlButtons;
